var STATUS_TRANSLATIONS = [
    'ats.pipeline.new',
    'ats.pipeline.to_be_called',
    'ats.pipeline.not_reached',
    'ats.pipeline.called',
    'ats.pipeline.short_meeting',
    'ats.pipeline.meeting',
    'ats.pipeline.hire',
    'ats.pipeline.reject',
];
var PipelineHelper = /** @class */ (function () {
    function PipelineHelper() {
    }
    Object.defineProperty(PipelineHelper.prototype, "totalStatuses", {
        get: function () {
            return STATUS_TRANSLATIONS.length;
        },
        enumerable: false,
        configurable: true
    });
    PipelineHelper.prototype.getTranslationKeyForStatusId = function (id) {
        if (id >= this.totalStatuses || id < 0) {
            throw new Error("No status translation for " + id);
        }
        return STATUS_TRANSLATIONS[id];
    };
    return PipelineHelper;
}());
export { PipelineHelper };
